import {useSelector } from "react-redux";
import { RootState } from "toolkit/store";

const useSelectedAddress = () => {

  const { selected } = useSelector((state: RootState) => state.selectedAddress);

  return selected
};

export default useSelectedAddress;
